import { render } from "./심혈관센터.vue?vue&type=template&id=665e81cd"
import script from "./심혈관센터.vue?vue&type=script&lang=js"
export * from "./심혈관센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__